import ImgOrderBy from '@/assets/images/order-by.png'
import ImgOrderCg from '@/assets/images/order-cg.png'
import ImgOrderQt from '@/assets/images/order-qt.png'
import ImgOrderWx from '@/assets/images/order-wx.png'
import ImgOrderXj from '@/assets/images/order-xj.png'
import ImgOrderYs from '@/assets/images/order-ys.png'

const globalEnum = {
    resourceType: {
        'root': 0,
        'directory': 1,
        'menu': 2,
        'action': 3,
        'tab': 4,
        'group': 5
    },
	yesOrNo: {
		'Yes': 1,
		'No': 0
    },
    sex: {
		'Male': 1,
		'Female': 0
    },
    // 长进度
    STEPS: {
        "step1": [1, "接单"],
        "step2": [2, "现场查勘"],
        "step3": [3, "方案制定"],
        "step4": [4, "工作准备"],
        "step5": [5, "现场实施"],
        "step6": [6, "完工"]
    },
    // 短进度
    SIMPLE_STEPS: {
        "step1": [1, "接单"],
        "step2": [2, "完工"]
    },
    // 工单服务类型
    SERVICE_TYPE: {
        "WX": ['WX', "维修", {
            module: "1",
            bgc: "#477AFF",
            deepColor: "#1E49D2",
            icon: "weixiu",
            img: ImgOrderWx,
            path: "/pages/components/classfy-info/classfy-info?serviceType=WX",
            formPath: "/pages/service-type-form/service-form/service-form",
            problemCode: "pepair_fault_type",
            problemText: "故障类型",
            warrantyText: "质保范围"
        }],
        "XJ": ['XJ', "巡检", {
            module: "2",
            bgc: "#B072FF",
            deepColor: "#852BEC",
            icon: "xunjian",
            img: ImgOrderXj,
            path: "/pages/components/classfy-info/classfy-info?serviceType=XJ",
            formPath: "/pages/service-type-form/inspect-form/inspect-form",
            problemCode: "inspect_fault_type",
            problemText: "故障类型",
            warrantyText: "质保范围"
        }],
        "BY": ['BY', "保养", {
            module: "3",
            bgc: "#FF5C25",
            deepColor: "#E83600",
            icon: "baoyang",
            img: ImgOrderBy,
            path: "/pages/components/classfy-info/classfy-info?serviceType=BY",
            formPath: "/pages/service-type-form/maintain-form/maintain-form",
            problemCode: "maintain_type",
            problemText: "保养类型",
            warrantyText: "质保范围"
        }],
        "QT": ['QT', "其他", {
            module: "4",
            bgc: "#FFB40C",
            deepColor: "#DD8100",
            icon: "xiangmu",
            img: ImgOrderQt,
            path: "/pages/components/classfy-info/classfy-info?serviceType=QT",
            formPath: "/pages/service-type-form/project-form/project-form",
            problemCode: "proj_type",
            problemText: "项目类型",
            warrantyText: ""
        }],
        "YS": ['YS', "验收", {
            module: "5",
            bgc: "#0FC0D6",
            deepColor: "#018BA4",
            icon: "xiangmuyanshou",
            img: ImgOrderYs,
            path: "/pages/components/classfy-info/classfy-info?serviceType=YS",
            formPath: "/pages/service-type-form/acceptance-form/acceptance-form",
            problemCode: "accept_fault_type",
            problemText: "验收主要问题",
            warrantyText: ""
        }],
        "CG": ['CG', "采购", {
            module: "6",
            bgc: "#59D799",
            deepColor: "#03AC5B",
            icon: "caigou",
            img: ImgOrderCg,
            path: "/pages/components/classfy-info/classfy-info?serviceType=CG",
            formPath: "/pages/service-type-form/buy-form/buy-form",
            problemCode: "",
            problemText: "",
            warrantyText: ""
        }],
    },
    // 星级
    SCORE_LEVEL: {
        "level1": [1, "非常差"],
        "level2": [2, "差"],
        "level3": [3, "一般"],
        "level4": [4, "好"],
        "level5": [5, "非常好"]
    },
}

export default globalEnum